import { useNavigate } from "react-router-dom";
import { clearAuth } from "../lib/api";

interface LayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  isAdmin?: boolean;
  onExport?: () => void;
}

export default function Layout({
  children,
  showHeader = true,
  isAdmin = false,
  onExport,
}: LayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-slate-900 text-slate-100">
      {showHeader && (
        <header className="flex-shrink-0 flex items-center justify-between px-4 sm:px-6 py-3 border-b border-slate-800 bg-slate-900/80 backdrop-blur-sm z-10">
          <button
            onClick={() => navigate("/dashboard")}
            className="text-lg font-semibold tracking-tight text-white hover:text-blue-400 transition-colors"
          >
            Architect
          </button>
          <div className="flex items-center gap-3">
            {isAdmin && (
              <span className="text-xs px-2 py-0.5 rounded-full bg-purple-500/20 text-purple-400 font-medium">
                Admin
              </span>
            )}
            {onExport && (
              <button
                onClick={onExport}
                className="text-xs text-slate-400 hover:text-white border border-slate-700 rounded px-2.5 py-1 transition-colors"
              >
                Export
              </button>
            )}
            <button
              onClick={() => {
                clearAuth();
                navigate("/", { replace: true });
              }}
              className="text-xs text-slate-500 hover:text-white transition-colors"
            >
              Logout
            </button>
          </div>
        </header>
      )}
      <main className="flex-1 min-h-0 flex flex-col">{children}</main>
    </div>
  );
}
